<template>
    <section class="padding-vertical-content mrgn-tp" key="paso1" id="paso1" ref="seleccionaEntradas">
        <div class="container" v-if="tipo_proceso_online === 1">
            <div class="row">
                <div class="col-12">
                    <h2 class="m-0 h1 text-uppercase">
                        {{ !event.reserva_instalaciones ? $t('partido.selecciona_entradas', { entradas: footer.termino_entradas }) : $t('partido.selecciona_reservas') }}
                    </h2>
                </div>

                <div class="col-12">
                    <transition name="fade" mode="out-in">
                        <div class="row" key="zonas" id="zonas">
                            <div class="col-lg-8">
                                <h3 class="subtitle h3 light mb-3">A) {{ $t('partido.pinchando_mapa') }}:</h3>
                                <ContentOrLoading style="min-height: 400px;">
                                    <template v-if="!loading_zonas">
                                        <div class="lightgray-content" v-show="!paso1_loading">
                                            <SvgComponent 
                                                :zonas="zonas_formated" 
                                                :place="event.place" 
                                                :sesion_id="sesion_id"
                                                @clickZona="finalizarPasoUno"
                                                @cargado="onMapaCargado"
                                            />											
                                        </div>
                                        <div class="row" v-if="paso1_loading">
                                            <div class="col-12 text-center" style="height: 400px">
                                                <LoaderComponent></LoaderComponent>
                                            </div>
                                        </div>
                                    </template>
                                </ContentOrLoading>
                            </div>

                            <div class="col-12 col-lg-4" v-if="isMapaCargado">
                                <h3 class="subtitle h3 light mb-3">B) {{ $t('partido.tabla') }}:</h3>
                                <div class="lightgray-content p-2 pb-0" id="tabla-sectores">
                                    <ContentOrLoading style="min-height: 400px;">
                                        <TablaSectoresComponent v-if="!loading_zonas" :zonas="zonas_formated" v-on:goTo="finalizarPasoUno"></TablaSectoresComponent>
                                    </ContentOrLoading>                                    
                                </div>
                            </div>
                        </div>						
                    </transition>
                </div>
            </div>
        </div>        
        <SeccionesComponent
            v-if="tipo_proceso_online === 2"
            :event="event"
            :sesion_id="sesion_id"
            @terminar="finalizarPasoUno"
        />
    </section>
</template>

<script>
import SvgComponent from '@/components/svg/SvgComponent';
import TablaSectoresComponent from '@/components/frontend/events/compra/TablaSectoresComponent';
import SeccionesComponent from '../components/secciones/SeccionesComponent'

export default {
    props: {
        event: {
            type: Object,
            required: true
        },
        sesion_id: {
            type: Number,
            required: true
        },
        zonas: {
            type: Array,
            required: true
        },
        loading_zonas : {
            type: Boolean,
            required: true,
            default: false
        },
        zonas_formated: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            paso1_loading: true,
            isMapaCargado: false
        }
    },
    mounted() {
        this.$refs.seleccionaEntradas.scrollIntoView({ behavior: 'smooth' });
    },
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        tipo_proceso_online() {
            return this.event.place.tipo_proceso_online;
        }
    },
    methods: {
        finalizarPasoUno(zona) {
            this.$emit('terminar', zona);
        },
        setSvgGeneral(svg) {
            this.$emit('setSvgGeneral', svg);
        },
        onMapaCargado() {
            this.isMapaCargado = true;
            this.paso1_loading = false;
        }
    },
    components: {
        SvgComponent, TablaSectoresComponent, SeccionesComponent
    }
}
</script>
